import { ISofaTaskPaneStrings } from "./myStrings.model";
import { CZ } from "./cs-cz";
import { EN } from "./en-us";

export const UIStrings = (() => {
  let strings: { [key: string]: ISofaTaskPaneStrings } = {};

  // JSON object for Czech strings
  strings.CZ = CZ();
  // JSON object for English strings
  strings.EN = EN();

  function getLocaleStrings(locale: string): ISofaTaskPaneStrings {
    let text;
    const loc = locale.toUpperCase();
    // Get the resource strings that match the language
    switch (loc) {
      case "CS-CZ":
        text = strings.CZ;
        break;
      case "EN-US":
        text = strings.EN;
        break;
      case "EN-GB":
        text = strings.EN;
        break;
      default:
        text = strings.CZ;
        break;
    }
    return text;
  }

  return { getLocaleStrings };
})();
